import Slider from "react-slick";
import { useContext, useEffect, useState } from "react";
import { isEmpty } from "lodash";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Modal,
  ModalBody,
  Nav, NavItem, NavLink, TabContent, TabPane,
} from "reactstrap";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

import OLMap from "../../../helpers/OLMap/OLMap";
import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import Icon from "./../../../components/Icon/Icon";
import EmptyData from "./../../../helpers/EmptyData/EmptyData";
import HotelStars from "../../../helpers/HotelStars/HotelStars";
import Currency, { ConvertCurrency } from "../../../helpers/Currency/Currency";
import { hotelUserContext } from "../../../context/UserContext/HotelUserContext/HotelUserContext";
import { Block } from "../../../components/Block/Block";
import { Col, Row } from "./../../../components/Grid/Grid";
import {
  convertRoleToPath,
  numberSeparate,
  productSliderOptions,
} from "../../../utils";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";
import moment from "jalali-moment";

const HotelUser = () => {
  const auth = useSelector((state) => state.auth);

  const navigate = useNavigate();
  const { id } = useParams();

  const [searchParams] = useSearchParams();

  const { hotel, rooms, room, setRoom, handleGetHotel } =
    useContext(hotelUserContext);

  const [currentSlide, setCurrentSlide] = useState({});
  const [isShowDesc, setIsShowDesc] = useState(false);
  const [isShowFacilities, setIsShowFacilities] = useState(false);
  const [isShowAddress, setIsShowAddress] = useState(false);

  const from = searchParams.get("from");
  const to = searchParams.get("to");

  // price for room Per Night
  const daysDiffer = moment(to).diff(from, 'days')

  useEffect(() => {
    if (!!id && !!from && !!to) handleGetHotel();
  }, [id, from, to]);

  useEffect(() => {
    if (!isEmpty(hotel.cover_media)) setCurrentSlide(hotel.cover_media);
  }, [hotel.cover_media]);

  // fix gallery
  const getDisplayItems = (gallery) => {
    if (!gallery || gallery.length === 0) return [];

    // If there are fewer than 2 items, fill the rest with the first item
    const itemsToDisplay = [...gallery];
    while (itemsToDisplay.length < 2) {
      itemsToDisplay.push(gallery[0]);
    }

    return itemsToDisplay;
  };

  // Changes slides
  const slideChange = (index) => {
    // var picture = hotel?.gallery?.find((_, _index) => _index === index);
    const gallery = getDisplayItems(hotel?.gallery)
    const picture = gallery.find((_, _index) => _index === index)
    setCurrentSlide(picture);
  };

  // Tabs
  const [activeTab, setActivetab] = useState("tAbout");
  const toggle = (tab) => { setActivetab(tab) };

  // Change room count
  const handleChangeRoomCount = (count) => {
    if (count < 1 || count > room.available_rooms)
      return toastErrorMessage("تعداد اتاق بیشتر از حد مجاز");

    const item = { ...room };
    item.count = count <= 1 ? 1 : count;

    setRoom(item);
  };

  if (isEmpty(hotel)) return <EmptyData />;

  const title = `${hotel?.accommodation_type ?? ""} ${hotel?.title ?? ""}`;

  const displayItems = getDisplayItems(hotel?.gallery || []);

  return (
    <>
      <SiteTitle title={title} />
      <Block>
        <Row>
          <Col xxl={6} className='p-1 mt-xxl-3'>
            <div className="product-gallery mr-xl-1 mr-xxl-5 no-bdr">
              <div className="rounded-lg">
                <img
                  src={currentSlide.media}
                  style={{ maxHeight: '70vh', objectFit: 'cover' }}
                  className="rounded w-100"
                  alt={currentSlide.title}
                  title={currentSlide.title}
                  loading="lazy"
                />
              </div>
              <Slider afterChange={slideChange} {...productSliderOptions} className="mt-2">
                {displayItems.map((item) => (
                  <div
                    className={`slider-item ${currentSlide.id === item.id ? "slick-current" : ""
                      } px-1`}
                    key={item.id}
                  >
                    <div className="thumb">
                      <img
                        style={{ objectFit: 'cover', height: '80px', width: '100px' }}
                        src={item.media}
                        alt={item.title}
                        title={item.title}
                        loading="lazy"
                        className="img-fluid rounded"
                      />
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </Col>
          <Col xxl={6} className='mt-xxl-3'>
            <Card className="no-bdr">
              <CardBody>
                <Col>
                  <div className="mt-2 d-flex justify-content-between">
                    <h2 className="product-title">{title}</h2>
                    <div className="product-rating">
                      <ul className="rating">
                        <HotelStars stars={hotel.stars} />
                      </ul>
                    </div>
                  </div>
                  <p className="fs-14px fw-bold text-muted ml-1">
                    {hotel.address}
                  </p>
                </Col>

                {/* ---- ---- --- >> Tabs << --- ---- ---- */}
                <div className="product-info mr-xxl-5">

                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        tag='a'
                        href="#tab"
                        active={activeTab === "tAbout"}
                        onClick={(ev) => {
                          ev.preventDefault();
                          toggle("tAbout");
                        }}
                      >
                        درباره هتل
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        tag='a'
                        href="#tab"
                        active={activeTab === "tFacility"}
                        onClick={(ev) => {
                          ev.preventDefault();
                          toggle("tFacility");
                        }}
                      >
                        امکانات
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        tag='a'
                        href="#tab"
                        active={activeTab === "tRooms"}
                        onClick={(ev) => {
                          ev.preventDefault();
                          toggle("tRooms");
                        }}
                      >
                        لیست اتاق ها
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        tag='a'
                        href="#tab"
                        active={activeTab === "tMap"}
                        onClick={(ev) => {
                          ev.preventDefault();
                          toggle("tMap");
                        }}
                      >
                        نقشه
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="tAbout">
                      {hotel.description && (

                        <div
                          className="product-excrept text-soft cursor-pointer"
                          onClick={() => setIsShowDesc(!isShowDesc)}
                        >
                          <div className="d-flex align-items-center">
                            <h6>درباره هتل</h6>
                          </div>
                          <p
                            className="lead text-justify"
                            style={{ height: "auto", }}
                            dangerouslySetInnerHTML={{
                              __html: hotel.description,
                            }}
                          />

                          <div className="w-100 d-flex justify-content-between align-items-center">
                            <p>{`شروع قیمت از`}</p>
                            <p className="d-flex justify-content-center align-items-center">
                              <h6 className="mr-1">{numberSeparate(rooms[0]?.pricing?.local_price / daysDiffer)}</h6>
                              تومان
                            </p>
                          </div>
                          <div className="mt-4 w-100">
                            <Button
                              color="primary"
                              size="lg"
                              className="w-100"
                              onClick={() => toggle("tRooms")}
                            >
                              <p className="w-100 text-center">
                                مشاهده اتاق‌ها
                              </p>
                            </Button>
                          </div>
                        </div>
                      )}
                    </TabPane>
                    <TabPane tabId="tFacility">
                      <div
                        className="product-meta cursor-pointer"
                        onClick={() => setIsShowFacilities(!isShowFacilities)}
                      >
                        <div className="d-flex align-items-center">
                          <h6>امکانات</h6>
                        </div>
                        <ul className="row">
                          {hotel?.policy?.facilities?.map((item) => (
                            <li
                              key={item.id}
                              className="col-6 col-sm-4 col-md-3 my-1"
                            >
                              <div className="fs-14px fw-bold text-muted">
                                {item.title}
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </TabPane>
                    <TabPane tabId="tRooms" >
                      <h4 className="mb-3">اتاق ها</h4>
                      {isEmpty(rooms) ? (
                        <EmptyData title="اتاقی برای نمایش یافت نشد" />
                      ) : (
                        <div style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '10px'
                        }}>
                          {rooms?.map((item) => (
                            <Card className="card-bordered" key={item.id}>
                              <CardBody className="px-1 py-0">
                                <Row className="align-items-center justify-content-between">
                                  <Col size="12" sm="6" md="4" lg="4" className="my-2">
                                    <h6>اتاق {item.title}</h6>
                                    <hr className="hr border-light" />
                                    <div className="text-justify text-muted">
                                      {item.description}
                                    </div>
                                  </Col>
                                  <Col size="12" md="8" lg="8" className="mt-2 p-0 text-center row w-100 d-flex align-center justify-between">
                                    <div className="col-12 col-md-8 d-flex align-center w-100">
                                      <p className="m-0 mr-1 flex-grow-1">اقامت برای {daysDiffer} شب</p>
                                      <div className="d-flex align-center">
                                        {item?.pricing?.deal_percent > 0 ? (
                                          <>
                                            <div className="mx-1">
                                              <Badge color="danger">
                                                % {item?.pricing?.deal_percent}
                                              </Badge>
                                            </div>
                                            <div className="mx-1">
                                              <div>
                                                <del>
                                                  <ConvertCurrency
                                                    price={item?.pricing?.local_price}
                                                    per={daysDiffer | 1}
                                                  />
                                                </del>
                                              </div>
                                              <div className="fa-lg">
                                                <ConvertCurrency
                                                  price={item?.pricing?.local_price_off}
                                                  per={daysDiffer | 1}
                                                />
                                              </div>
                                            </div>
                                          </>
                                        ) : (
                                          <div className="fa-lg">
                                            <ConvertCurrency
                                              price={item?.pricing?.local_price_off}
                                              per={daysDiffer | 1}
                                            />
                                          </div>
                                        )}
                                        <div className="mr-1">
                                          <Currency />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="d-flex col-12 col-md-3 mx-1 my-2 w-100">
                                      <Button
                                        className="no-bdr bg-orange w-100 d-flex align-center justify-center"
                                        size="md"
                                        onClick={() => {
                                          setRoom({ ...item, hotel, count: 1, from, to })
                                          navigate(`/${convertRoleToPath(auth.role)}/reserve/hotel`, {
                                            state: { ...item, hotel, count: 1, from, to },
                                          })
                                        }}
                                        disabled={item.available_rooms <= 0}
                                      >
                                        {item.available_rooms <= 0
                                          ? "تکمیل ظرفیت"
                                          : "انتخاب اتاق"}
                                      </Button>
                                    </div>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          ))}
                        </div>
                      )}
                    </TabPane>
                    <TabPane tabId="tMap">
                      <div
                        className="product-meta cursor-pointer"
                        onClick={() => setIsShowAddress(true)}
                      >
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <h6>آدرس {hotel?.accommodation_type}</h6>
                          <span>
                            <p className="text-center font-weight-bold text-dark">
                              + نمایش روی نقشه
                            </p>
                          </span>
                        </div>

                        <div className="d-flex align-items-center">
                          <img src="/assets/images/icons/map_bg.jpg" alt="" />
                          <p className="fs-14px fw-bold text-muted ml-3">
                            {hotel.address}
                          </p>
                        </div>
                      </div>
                    </TabPane>
                  </TabContent>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Block>

      <Modal
        isOpen={isShowAddress}
        className="modal-dialog-centered"
        size="md"
        toggle={() => setIsShowAddress(false)}
      >
        <ModalBody>
          <span
            type="button"
            onClick={() => setIsShowAddress(false)}
            className="close"
          >
            <Icon name="cross-sm" />
          </span>
          <div className="p-2">
            <h6 className="title">آدرس {hotel?.accommodation_type}</h6>
            <br />
            <OLMap
              className="rounded border p-1"
              latitude={hotel?.latlon[0]}
              longitude={hotel?.latlon[1]}
              style={{ width: "auto", height: "400px" }}
            />
          </div>

          <p className="fs-14px fw-bold text-muted ml-3">{hotel.address}</p>
        </ModalBody>
      </Modal>
    </>
  );
};

export default HotelUser;
